import { environment } from "../../environments/environment";
export const siteKey: any = environment.siteKey;
